
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AngleUpDownIcon',
  props: {
    up: {
      type: Boolean,
      required: true
    }
  }
})
